import { useEffect } from 'react';

import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import { captureException } from '@sentry/browser';
import { DocumentNode } from 'graphql';

import { PageMetaContext } from '../context/PageMetaContext';
import { useNotNullableContext } from './useNotNullableContext';

export default function useFullPageQuery<TQuery>(
  query: DocumentNode,
  options: QueryHookOptions = {},
): QueryResult<TQuery> {
  const { pageType, pageSlug, isPreview, pageGuid } = useNotNullableContext(
    PageMetaContext,
  );

  const result = useQuery<TQuery>(query, {
    ...options,
    variables: {
      type: pageType.toUpperCase(),
      slug: pageSlug,
      id: pageGuid,
      preview: isPreview,
      ...options.variables,
    },
    ssr: false, // We do all our server side queries through our base page query
    errorPolicy: 'all',
    skip: typeof window === 'undefined',
  });

  useEffect(() => {
    if (result.error) {
      captureException(result.error);
    }
  }, [result.error]);

  return result;
}
